import Vue from 'vue'
import Router from 'vue-router'
import Main from './layouts/Main.vue'
import Home from './views/Home.vue'
import {
  helper
} from '@ymt/gfw-axios'
import store from './stores'
const chat = () => import('@/views/chat.vue')
const videoManagement = () => import('@/views/video_management/index.vue')

Vue.use(Router)
const router = new Router({
  // mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue'),
    beforeEnter(to, from, next) {
      if (helper.checkLogin()) {
        if (to.query.redirect) {
          next({
            path:to.query.redirect
          })
        } else {
          next({
            name: 'home'
          })
        }
      } else {
        next()
      }
    },
    meta: {
      menuResourceUrl: 'home'
    }
  },
  {
    path: '/',
    component: Main,
    props(route) {
      return {
        hideBreadcrumb: route.name === 'home'
      }
    },
    meta: {
      requiresAuth: true, // 需要登录
      menu: {
        label: '首页'
      }
    },
    children: [{
      path: '',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true, // 需要登录
        menu: {
          label: '首页'
        },
        menuResourceUrl: 'home'
      }
    },
    // {
    //   path: 'supply',
    //   name: 'supply',
    //   component: () =>
    //     import(/* webpackChunkName: "supply" */ './views/Supply.vue'),
    //   meta: {
    //     title: '货品管理',
    //     requiresAuth: true, // 需要登录
    //     menu: {
    //       hasHistory: true,
    //       label: '货品管理'
    //     },
    //     menuResourceUrl: 'supply'
    //   }
    // },
    {
      path: 'supply_list/:typeId',
      name: 'supplyList',
      component: () =>
            import(/* webpackChunkName: "supply" */ './views/SupplyList.vue'),
      meta: {
        title: '供应管理',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '供应管理',
          params: 'typeId'
        },
        menuResourceUrl: 'supplyList'
      }
    },
    {
      path: 'publish_supply',
      name: 'publishSupply',
      component: () =>
            import(/* webpackChunkName: "supply" */ './views/PublishSupply.vue'),
      meta: {
        keepAlive: false,
        title: '发布供应',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '发布供应'
        },
        menuResourceUrl: 'publishSupply'
      }
    },
    {
      path: 'publish_supply/:supplyId',
      name: 'editSupply',
      component: () =>
            import(/* webpackChunkName: "supply" */ './views/PublishSupply.vue'),
      meta: {
        title: '供应详情',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '供应详情'
        }
        // menuResourceUrl: 'publishSupply'
      }
    },
    {
      path: 'publish_success',
      name: 'publishSuccess',
      component: () =>
            import(/* webpackChunkName: "supply" */ './views/PublishSuccess.vue'),
      meta: {
        title: '发布成功',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '发布成功'
        },
        menuResourceUrl: ''
      }
    },
    {
      path: 'supply_config',
      name: 'supplyConfig',
      component: () =>
            import(/* webpackChunkName: "supply" */ './views/supplyConfig.vue'),
      meta: {
        title: '供应配置',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '运费模版'
        },
        menuResourceUrl: 'supplyConfig'
      }
    },
    {
      path: 'order_list',
      name: 'orderList',
      component: () =>
            import(/* webpackChunkName: "order" */ './views/OrderList.vue'),
      meta: {
        title: '订单管理',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '订单管理'
        },
        menuResourceUrl: 'orderList'
      }
    },
    {
      path: 'supply_order',
      name: 'supply_order',
      component: () => import('./views/OrderList.vue'),
      meta: {
        title: '供货订单',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '供货订单'
        },
        menuResourceUrl: 'supply_order'
      }
    },
    {
      path: 'batch_delivery',
      name: 'batch_delivery',
      component: () => import('./views/BatchDelivery.vue'),
      meta: {
        title: '批量发货',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '批量发货'
        },
        menuResourceUrl: 'batch_delivery'
      }
    },
    {
      path: 'chat',
      name: 'chat',
      component: chat,
      meta: {
        title: '聊天消息',
        requiresAuth: true, // 需要登录
        menu: {
          hasHistory: true,
          label: '聊天消息'
        },
        menuResourceUrl: 'chat'
      }
    },
    {
        path: 'videoManagement',
        name: 'videoManagement',
        component: videoManagement,
        redirect:'/videoManagement/video_home_index',
        meta: {
          title: '视频管理',
          requiresAuth: true, // 需要登录
          menu: {
            hasHistory: true,
            label: '视频管理'
          },
          menuResourceUrl: 'videoManagement'
        },
        children: [
          {
            path: 'video_home_index',
            name: 'video_home_index',
            component: () => import('./views/video_management/Home.vue'),
            meta: {
              title: '视频首页',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: ''
              },
              menuResourceUrl: 'video_home_index'
            }
          },
          {
            path: 'create_video',
            name: 'create_video',
            component: () => import('./views/video_management/Create.vue'),
            meta: {
              title: '视频创建',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '视频创建'
              },
              menuResourceUrl: 'create_video'
            }
          },
          {
            path: 'edit_video',
            name: 'edit_video',
            component: () => import('./views/video_management/Edit.vue'),
            meta: {
              title: '视频创建',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '视频创建'
              },
              menuResourceUrl: 'edit_video'
            }
          },
          {
            path: 'sample_preview',
            name: 'sample_preview',
            component: () => import('./views/video_management/SamplePreview.vue'),
            meta: {
              title: '样片预览',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '视频创建'
              },
              menuResourceUrl: 'sample_preview'
            }
          },
          {
            path: 'create_video_history',
            name: 'create_video_history',
            component: () => import('./views/video_management/CreateVideoHistory.vue'),
            meta: {
              title: '生成历史',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '生成历史'
              },
              menuResourceUrl: 'create_video_history'
            }
          },
          {
            path: 'knowledge_library',
            name: 'knowledge_library',
            component: () => import('./views/video_management/KnowledgeLibrary.vue'),
            meta: {
              title: '知识库',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '知识库'
              },
              menuResourceUrl: 'create_video_history'
            }
          },
          {
            path: 'material_management',
            name: 'material_management',
            component: () => import('./views/video_management/MaterialManagement.vue'),
            meta: {
              title: '素材管理',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '素材管理'
              },
              menuResourceUrl: 'material_management'
            }
          },{
            path: 'account_list',
            name: 'account_list',
            component: () => import('./views/video_management/AccountList.vue'),
            meta: {
              title: '矩阵号授权',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '矩阵号授权'
              },
              menuResourceUrl: 'account_list'
            }
          },{
            path: 'auto_publish',
            name: 'auto_publish',
            component: () => import('./views/video_management/AutoPublish.vue'),
            meta: {
              title: '自动发布',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '自动发布'
              },
              menuResourceUrl: 'auto_publish'
            }
          },
          {
            path: 'clone_sound',
            name: 'clone_sound',
            component: () => import('./views/video_management/CloneSound.vue'),
            meta: {
              title: '克隆声音',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '克隆声音'
              },
              menuResourceUrl: 'clone_sound'
            }
          },
          {
            path: 'material_detail/:id',
            name: 'material_detail',
            component: () => import('./views/video_management/MaterialDetail.vue'),
            meta: {
              title: '素材详情',
              requiresAuth: true,
              menu: {
                hasHistory: true,
                label: '素材详情'
              },
              menuResourceUrl: 'material_management'
            }
          }
        ]
      },
    ]
  },
  {
    path: '/place_of_origin/:place',
    component: () => import('./views/PlaceOfOrigin.vue'),
    redirect:'/place_of_origin/:place/merchants_homepage',
    meta: {
      title: '产地管理',
      requiresAuth: true,
      menu: {
        label: '产地'
      }
    },
    children: [
      {
        path: 'merchants_homepage',
        name: 'merchants_homepage',
        component: () => import('./views/MerchantsHomepage.vue'),
        meta: {
          title: '商家首页',
          requiresAuth: true,
          menu: {
            hasHistory: true,
            label: '商家首页'
          },
          menuResourceUrl: 'merchants_homepage'
        }
      },
      {
        path: 'producer_service',
        name: 'producer_service',
        component: () => import('./views/ProducerService.vue'),
        meta: {
          title: '产地服务',
          requiresAuth: true,
          menu: {
            hasHistory: true,
            label: '产地服务'
          },
          menuResourceUrl: 'producer_service'
        }
      },
      {
        path: 'other_admin',
        name: 'other_admin',
        component: () => import('./views/OhterAdmin.vue'),
        meta: {
          title: '其他管理',
          requiresAuth: true,
          menu: {
            hasHistory: true,
            label: '其他管理'
          },
          menuResourceUrl: 'other_admin'
        }
      },
    ]
  },
  {
    path: '*',
    name: 'notfound',
    component: () => import('./views/404.vue')
  }
  ]
})
router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.title) {
    window.document.title = to.meta.title
  } else {
    window.document.title = '一亩田商户端'
  }
  if (to.path.includes('videoManagement')) {
    // 切换为黑色主题
    document.documentElement.setAttribute('data-theme', 'dark');
  } else {
    // 切换回默认主题
    document.documentElement.setAttribute('data-theme', 'default');
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!helper.checkLogin()) {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
  store.commit('setResourceUrl', to.meta.menuResourceUrl)
  store.commit('setResourcePath', to.path)
  if (to.meta && to.meta.menu && to.meta.menu.hasHistory) {
    // 首页菜单历史
    store.commit('updateMenuHistoryList', to.name)
  }
})
router.afterEach(() => {
  let ele = document.getElementsByClassName('over_auto')[0]
  if (ele) {
    ele.scrollTop = 0
  }
})
export default router
